import { render, staticRenderFns } from "./SchoolBaseInput.vue?vue&type=template&id=fed88bac&scoped=true&"
import script from "./SchoolBaseInput.vue?vue&type=script&lang=js&"
export * from "./SchoolBaseInput.vue?vue&type=script&lang=js&"
import style0 from "./SchoolBaseInput.vue?vue&type=style&index=0&id=fed88bac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed88bac",
  null
  
)

export default component.exports